





















































import { Component, Prop, Mixins } from "vue-property-decorator";
import VAccordion from "@/components/VAccordion.vue";
import ModelParserMixin from "@/mixins/ModelParser";
import VSelect from "@/components/VSelect.vue";
import { currentScoutingStore } from "@/store/typed";
import ScoutingAreaItem from "@/components/ScoutingArea/Item.vue";

@Component({
  components: {
    VAccordion,
    ScoutingAreaItem,
    VSelect,
  },
})
export default class ScoutingPlaceCollapsableList extends Mixins(
  ModelParserMixin
) {
  @Prop({ default: true }) readonly deletable!: boolean;
  @Prop({ default: false }) readonly searchable!: boolean;
  @Prop({ default: false }) readonly showLegend!: boolean;
  @Prop({ default: false }) readonly isOpened!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: true }) readonly canClose!: boolean;

  private sourceTypes = [
    { id: "Region", text: "Regione" },
    { id: "District", text: "Provincia" },
    { id: "Town", text: "Comune" },
    { id: "TownArea", text: "CAP" },
  ];
  private granularity = "";
  private searchTerm = "";

  async load() {}

  get scoutingAreas() {
    return currentScoutingStore.scoutingAreas;
  }

  onStatusChanged(closed: boolean) {
    this.$emit("status", closed);
  }

  get areeCount() {
    return currentScoutingStore.scoutingAreas.length;
  }

  onSubmit() {
    if (this.granularity.length === 0 || this.searchTerm.length < 3) return;

    const selected = this.sourceTypes.find((o) => o.id === this.granularity);
    this.$router.push({
      name: "scouting-area-search",
      params: {
        term: this.searchTerm,
        granularity: this.granularity || "",
        granularityLabel: selected?.text || "",
      },
    });
  }
}
